import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";

const links = [
  { href: "#despre", label: "Despre Noi" },
  { href: "#beton", label: "Tipuri de Beton" },
  { href: "#proces", label: "Cum Comand" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-black/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
          <span className="inline-block w-2.5 h-2.5 bg-[#F59E0B]" />
          <div className="flex flex-col leading-none">
            <span className="font-display text-xl sm:text-2xl tracking-tight uppercase leading-none">
              Apolodor <span className="text-[#F59E0B]">Com</span> SRL
            </span>
            <span className="hidden sm:block font-mono-tech text-[9px] tracking-[0.25em] uppercase text-neutral-500 mt-1.5">
              Fetești · Slobozia
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="font-mono-tech text-[13px] uppercase tracking-[0.15em] text-neutral-700 hover:text-black transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a
            href="tel:0766693105"
            data-testid="nav-call-fetesti"
            className="btn-amber rounded-sm px-3 py-2.5 inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-wider"
          >
            <Phone className="w-3.5 h-3.5" strokeWidth={2.5} />
            <span className="flex flex-col items-start leading-none">
              <span className="text-[9px] tracking-[0.2em] opacity-70">FETEȘTI</span>
              <span className="mt-1">0766 693 105</span>
            </span>
          </a>
          <a
            href="tel:0722569492"
            data-testid="nav-call-slobozia"
            className="btn-ink rounded-sm px-3 py-2.5 inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-wider"
          >
            <Phone className="w-3.5 h-3.5 text-[#F59E0B]" strokeWidth={2.5} />
            <span className="flex flex-col items-start leading-none">
              <span className="text-[9px] tracking-[0.2em] opacity-70">SLOBOZIA</span>
              <span className="mt-1">0722 569 492</span>
            </span>
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-black/10">
          <div className="px-4 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-mono-tech text-sm uppercase tracking-[0.15em] text-neutral-800"
                data-testid={`mobile-nav-${l.href.replace("#", "")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:0766693105"
              data-testid="mobile-call-fetesti"
              className="btn-amber rounded-sm px-4 py-3 inline-flex items-center justify-between gap-2 text-sm font-bold uppercase tracking-wider mt-2"
            >
              <span className="flex items-center gap-2"><Phone className="w-4 h-4" /> Sună la Fetești</span>
              <span>0766 693 105</span>
            </a>
            <a
              href="tel:0722569492"
              data-testid="mobile-call-slobozia"
              className="btn-ink rounded-sm px-4 py-3 inline-flex items-center justify-between gap-2 text-sm font-bold uppercase tracking-wider"
            >
              <span className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#F59E0B]" /> Sună la Slobozia</span>
              <span>0722 569 492</span>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
